import React from 'react';
import { withTranslation } from 'react-i18next';
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';

const RemoveArticle = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.remove_article_from_blockchain')}
        type="button"
        onClick={onClick}><DeleteForeverIcon/></button></span>
)

export default withTranslation('dashboard')(RemoveArticle);
